import { toast as toastify, type ToastOptions } from 'react-toastify';

type ToastType = Pick<typeof toastify, 'success' | 'error' | 'info' | 'warning' | 'promise' | 'dismiss'>;

const defaultOptions: Pick<ToastOptions, 'position'> = {
    position: 'top-right'
};

const toast: ToastType['success'] = (msg, options = defaultOptions) => {
    return toastify.success(msg, options);
};

const toastObject: ToastType = {
    success: (msg, options = defaultOptions) => {
        return toastify.success(msg, options);
    },
    error: (msg, options = defaultOptions) => {
        return toastify.error(msg, options);
    },
    info: (msg, options = defaultOptions) => {
        return toastify.info(msg, options);
    },
    warning: (msg, options = defaultOptions) => {
        return toastify.warning(msg, options);
    },
    promise: <T,>(promise, promiseOptions, options = defaultOptions) => {
        return toastify.promise(promise, promiseOptions, options) as Promise<T>;
    },
    dismiss: (id?) => {
        return toastify.dismiss(id);
    }
};

export default Object.assign(toast, toastObject);
